import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { COMMIT_SCORE_TIME_SERIES } from "@/api/queries/commitScoreTimeSeries";

export type PredictionIndexEnum = "HIGH" | "MEDIUM" | "LOW";

export interface TimeSeriesDataPoint {
  date: string;
  value: number | null;
  index: PredictionIndexEnum | null;
}

export interface UseCommitScoreTimeSeriesReturn {
  timeSeries: TimeSeriesDataPoint[];
  loading: boolean;
  error: unknown;
  hasData: boolean;
}

export const useCommitScoreTimeSeries = (
  orgId?: string,
  userId?: string,
): UseCommitScoreTimeSeriesReturn => {
  const { data, loading, error } = useQuery(COMMIT_SCORE_TIME_SERIES, {
    variables: {
      orgId: orgId || "",
      userId: userId || "",
    },
    skip: !orgId || !userId,
  });

  const { timeSeries } = useMemo(() => {
    if (
      !data?.node ||
      data.node.__typename !== "Student" ||
      !data.node.commitScoreTimeSeries
    ) {
      return {
        timeSeries: [] as TimeSeriesDataPoint[],
      };
    }

    const timeSeriesData = data.node.commitScoreTimeSeries;
    const transformedTimeSeries = timeSeriesData.map((point) => ({
      date: point.date,
      value: point.value,
      index: point.index || null,
    }));

    return {
      timeSeries: transformedTimeSeries,
    };
  }, [data]);

  const hasData = timeSeries.length > 0;

  return {
    timeSeries,
    loading,
    error,
    hasData,
  };
};
